import React from "react";
import { StatisticTables } from 'scenes/management/statistics/data/tables'
import ManagementStatisticsStatisticsTable from "scenes/management/statistics/statistics/table";
import ManagementStatisticsChartsTable from 'scenes/management/statistics/chart/table'

const ManagementStatisticsDetailsScene = ({ statistics, data }) => {

	let rendered_statistics = null;

	switch( statistics ) {
		case 'bookings_created_by_month':
		case 'bookings_scheduled_by_month':
			rendered_statistics = (
				<ManagementStatisticsStatisticsTable
					statistic={ StatisticTables[ statistics ] }
				/>
			)
			break;
		
		case 'bookings_created_by_weekday':
		case 'bookings_scheduled_by_weekday':
			rendered_statistics = (
				<ManagementStatisticsStatisticsTable
					statistic={ StatisticTables[ statistics ] }
				/>
			)
			break;
			
		case 'bookings_created_by_day':
		case 'bookings_scheduled_by_day':
			rendered_statistics = (
				<ManagementStatisticsStatisticsTable
					statistic={ StatisticTables[ statistics ] }
				/>
			)
			break;
			
		case 'chart_employee_bookings_week':
		case 'chart_checkin_time':
		case 'chart_book_time':
			rendered_statistics = (
				<ManagementStatisticsChartsTable
					statistic={ StatisticTables[ statistics ] }
					data={ data }
				/>
			)
			break;
	}

	return rendered_statistics;
}

export default ManagementStatisticsDetailsScene
